import { logWithOffset } from "../../logWithOffset";
let settings = null;

const queueKlaviyoMessage = (args) => {
  //console.log("DOIN KLAVIYO");
  //console.log(args);
  window._learnq = window._learnq || [];
  window._learnq.push(args);
}


const isEnabled = () => {
  return typeof(settings.klaviyoPubKey) === 'string' && settings.klaviyoPubKey.length > 0;
};

const setup = async (s) => {
  settings = s;
  if (isEnabled()) {
    logWithOffset("Configuring Klaviyo");
    const head      = document.getElementsByTagName('head')[0];
    const newScript = document.createElement("script");
    newScript.src   = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${settings.klaviyoPubKey}`;
    head.appendChild(newScript);
  }
};

const handlePageView = async (e) => {
  queueKlaviyoMessage(['track', 'Active On Site', { '$event_id': e.eventId, 'locale': e.locale }]);
}

const handleAcceptUpsell = async (e) => {
}

const handleCheckoutStarted = async (e) => {
  if (typeof(e.email) === 'string' && e.email.length > 1) {
    queueKlaviyoMessage(['identify', { '$email': e.email, 'locale': e.locale }]);
  }

  const klaviyoData = {};

  klaviyoData.cctitle = e.primaryVariantTitle;
  klaviyoData.ccamount = e.primaryVariantComparePrice;
  klaviyoData.ccamount2 = e.primaryVariantPrice;
  klaviyoData.ccimage = e.primaryVariantImage;
  klaviyoData.comparePrice = e.primaryVariantComparePrice;
  klaviyoData.cartPrice = e.primaryVariantPrice;

  klaviyoData.sessionCartId    = e.sessionCartId;
  klaviyoData.cartBaseUrl      = `${window.location.protocol}://${window.location.hostname}${window.location.pathname}`;
  klaviyoData.cartUrlHostname  = window.location.hostname;
  klaviyoData.cartUrlPath      = window.location.pathname;
  klaviyoData.cartUrlSearch    = window.location.search.replace(/\?/, '');
  klaviyoData.cartUrlHash      = window.location.hash;
  klaviyoData.ccproduct        = window.location.href;
  klaviyoData.cartUrl          = window.location.href;
  klaviyoData.primaryVariantId = e.primaryVariantId;
  klaviyoData['$event_id']     = e.eventId;
  queueKlaviyoMessage(['track', 'Started Checkout', klaviyoData ]);
};

const fire = async (e) => {
  if (!isEnabled()) {
    return;
  }

  switch(e.eventType) {
    case 'page_view':
      return handlePageView(e);
    case 'accepted_upsell':
      return handleAcceptUpsell(e);
    case 'checkout_started':
      return handleCheckoutStarted(e);
  }
};

export default { setup, fire };
